import morphdom from 'morphdom';
import { error, verbose } from '../utils/logger';

export function mDom(config, templateString, store, renderOptions = {}) {
    let target;

    /* eslint-disable angular/document-service */
    if (config.multiple) {
        target = document.querySelector(config.componentLocation);
    } else {
        target = document.querySelector(config.templateLocation);
    }
    /* eslint-enable angular/document-service */

    if (!target) {
        error(`mDom Target Not Found: ${config.name}`);
        return;
    }

    morphdom(target, templateString.trim(), renderOptions);
    config.afterRender(store);
}

export function dDom(config, templateString, store) {
    if (config.multiple) {
        $(config.componentLocation).replaceWith(templateString);
    } else {
        $(config.templateLocation).replaceWith(templateString);
    }
    config.afterRender(store);
}

export function rebind(config, el, store) {
    verbose(`Rebinding component ${config.name}`);
    if (config.rootNode) {
        $(config.rootNode).attr('data-componentid', config.componentLocation);
        $(el).replaceWith(config.rootNode);
    } else {
        $(el).attr('data-componentid', config.componentLocation);
    }
    config.afterRebind(store);
    return config.rebindChildren(store);
}

/* eslint-disable complexity */
/**
 * Update $(toEL) form value to use $(fromEl) value on reRender
 * @param {Object} fromEl fromNode
 * @param {Object} toEl toNode
 * @param {Boolean} checkedStateAlreadySet (true if checked state is rendered in template)
 * @returns {Element} - Returns updated domElement with new value from fromEL node
 */
export function updateElChildrenValueOnRender(fromEl, toEl, checkedStateAlreadySet = false) {
    const $fromEl = $(fromEl);
    const $toElCopy = $(toEl);

    if ($fromEl.is('input') || $fromEl.is('textarea')) {
        $toElCopy.val($fromEl.val());
        if (!checkedStateAlreadySet) {
            if ($fromEl.is(':checked')) {
                $toElCopy.prop('checked', true);
            } else if ($toElCopy.is(':checked')) {
                $toElCopy.removeAttr('checked');
            }
        }
    } else if ($fromEl.is('select')) {
        $toElCopy.val($fromEl.val());
    }
    return $toElCopy;
}

/* eslint-enable complexity */

export const mDomMaintainInputValsCheckedStateSetInTemplate = {
    onBeforeElChildrenUpdated: (fromEl, toEl) => {
        /* eslint-disable no-param-reassign */
        toEl = updateElChildrenValueOnRender(fromEl, toEl, true);
        /* eslint-enable no-param-reassign */
        return true;
    }
};

export const mDomMaintainInputVals = {
    onBeforeElChildrenUpdated: (fromEl, toEl) => {
        /* eslint-disable no-param-reassign */
        toEl = updateElChildrenValueOnRender(fromEl, toEl);
        /* eslint-enable no-param-reassign */
        return true;
    }
};

// For facets, remove old links inside fromEl, so that only toEl's links will be merged inside
export const mDomFacetHomogenousLinkTypes = {
    onBeforeElChildrenUpdated: (fromEl, toEl) => {
        const $fromEl = $(fromEl);
        const $toEl = $(toEl);

        if ($fromEl.is('li') && $fromEl.attr('data-facet-name')) {
            const oldFacetGroupType = $fromEl.attr('data-facet-name');
            const newFacetGroupType = $toEl.attr('data-facet-name');

            if (oldFacetGroupType === newFacetGroupType) {
                const badChildAnchors = $fromEl.children(`a[data-element-name]`);

                if (badChildAnchors.length > 0) {
                    // console.debug(`Removing ${badChildAnchors.length} anchors from fromEl`);
                    badChildAnchors.remove();
                }
            }
        }

        return true;
    }
};

/**
 * A template of the morphdom callbacks that can be edited to debug mdom rendering bugs
 */
// export const mDomDebug = {
//     onBeforeNodeAdded: function(node) {
//         return node;
//     },
//     onNodeAdded: function(node) {
//     },
//     onBeforeElUpdated: function(fromEl, toEl) {
//         const $fromEl = $(fromEl);
//         const $toEl = $(toEl);

//         return true;
//     },
//     onElUpdated: function(el) {

//     },
//     onBeforeNodeDiscarded: function(node) {
//         return true;
//     },
//     onNodeDiscarded: function(node) {

//     },
//     onBeforeElChildrenUpdated: function(fromEl, toEl) {
//         const $fromEl = $(fromEl);
//         const $toEl = $(toEl);

//         return true;
//     }
// }

/**
 * UW-7901 - Fix for Mobile Safari having strict
 * one event -> one reflow policy
 * @param {String} selector CSS selector
 */
export function forcePageReflow(selector) {
    $(selector)
        .hide()
        .show(0);
}
